import { render, staticRenderFns } from "./NoteWidget.vue?vue&type=template&id=3ca96dd5&scoped=true&"
import script from "./NoteWidget.vue?vue&type=script&lang=js&"
export * from "./NoteWidget.vue?vue&type=script&lang=js&"
import style0 from "./NoteWidget.vue?vue&type=style&index=0&id=3ca96dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca96dd5",
  null
  
)

export default component.exports